module.exports = __webpack_public_path__ + "114e5c773573107ce9fd96b82b791ec2.svg";